import { Button, ComposedModal, Loading, ModalBody, ModalFooter, ModalHeader } from "carbon-components-react";
import React from "react";

const ConfirmModal = ({ show, onClose, onConfirm, title, contentMessage, confirmBtnText = "Confirm", loading }) => {
	return (
		<ComposedModal className="light-modal confirm-modal" open={show} onClose={onClose}>
			<ModalHeader className="margin-modal" title={title} />
			<ModalBody>
				{loading && <Loading active={true} withOverlay={true} description="Saving" />}
				<p style={{ margin: "20px 0px", fontSize: "1rem" }}>{contentMessage}</p>
			</ModalBody>

			<ModalFooter>
				<Button kind="secondary" onClick={onClose}>
					Cancel
				</Button>
				<Button kind="primary" onClick={onConfirm}>
					{confirmBtnText}
				</Button>
			</ModalFooter>
		</ComposedModal>
	);
};

export default ConfirmModal;
